module.exports = __webpack_public_path__ + "static/media/super_pack_en_ete_chat.044cf0b1.png";